import { jsx as _jsx } from "react/jsx-runtime";
const TONES = {
    ok: { background: 'var(--ok-bg)', color: 'var(--ok-fg)' },
    warn: { background: 'var(--warn-bg)', color: 'var(--warn-fg)' },
    danger: { background: 'var(--danger-bg)', color: 'var(--danger-fg)' },
    outline: { border: '1px solid var(--border-strong)', color: 'var(--text-3)', padding: '1px 7px' },
    muted: { color: 'var(--text-4)' },
};
export function Pill({ tone = 'outline', children, small, style }) {
    return (_jsx("span", { style: { display: 'inline-block', fontSize: small ? 10.5 : 11.5, fontWeight: 600, padding: small ? '1px 6px' : '2px 8px', borderRadius: 2, whiteSpace: 'nowrap', lineHeight: 1.5, ...TONES[tone], ...style }, children: children }));
}
//# sourceMappingURL=Pill.js.map